import { createSlice } from "@reduxjs/toolkit";
import { typedSplitString } from "@poscon/shared-types";
const initialState = {
    connection: null,
    socketConnected: false,
};
// TODO: create factory to make this generic
export const connectionSlice = createSlice({
    name: "connection",
    initialState,
    reducers: {
        setConnection(state, action) {
            state.connection = action.payload;
        },
        setSocketConnected(state, action) {
            state.socketConnected = action.payload;
        },
    },
    selectors: {
        connectionSelector: (state) => state.connection,
        sectorIdSelector: (state) => state.connection?.sectorId,
        artccIdSelector: (state) => state.connection?.sectorId ? typedSplitString(state.connection.sectorId, ".")[0] : null,
        socketConnectedSelector: (state) => state.socketConnected,
    },
});
export const connectionReducer = connectionSlice.reducer;
export const { setConnection, setSocketConnected } = connectionSlice.actions;
export const { connectionSelector, sectorIdSelector, artccIdSelector, socketConnectedSelector } = connectionSlice.getSelectors((state) => state.connection);
//# sourceMappingURL=connectionSlice.js.map